import { useRef, useState, useEffect } from 'react';
import { Card, CardText, Button } from "react-bootstrap";

export default function TeamRevealCard({ src, alt, name, role, description }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      style={{
        display: 'flex',
        alignItems: 'center',
        // marginBottom: '3rem',
        overflow: 'hidden', // clips the sliding text
      }}
    >
      {/* Left: image + name/role — fades in */}
      <div
        style={{
          opacity: visible ? 1 : 0,
           animation: visible ? 'focusIn 2.5s ease forwards' : 'none',
    animationDelay: visible ? '0s' : '0s',
          transition: 'opacity 0.6s ease',
          width: "100%", 
      maxWidth: "250px", 
          textAlign: 'center',
          flexShrink: 0,
        }}
      >
        <img
          src={src}
          alt={alt}
          style={{
            width: '160px',
            height: '160px',
            objectFit: 'cover',
            borderRadius: '12px',
            display: 'block',
            margin: '0 auto',
          }}
        />
        <h10 style={{ display: 'block', marginTop: '0.5rem', fontWeight: 'bold', color: 'white' }}>{name}</h10>
        <h11 style={{ display: 'block', marginTop: '0.2rem', fontWeight: 'bold', color: 'rgba(243,174,61,0.9)' }}>{role}</h11>
      </div>

      {/* Right: bio text — extends out like a drawer */}
      <div
        style={{
          
          opacity: visible ? 1 : 0,
          animation: visible ? 'focusIn 2.5s ease forwards' : 'none',
    animationDelay: visible ? '0s' : '0s',
          overflow: 'hidden',
          paddingLeft: visible ? '1.5rem' : '0',
          borderLeft: visible ? '3px solid rgba(92, 9, 9, 0.9)' : 'none',
          // borderBottom: '3px solid rgba(92, 9, 9, 0.9)',
          marginLeft: '1rem',
        }}
      >
        <CardText style={{
          margin: 0,
          whiteSpace: 'normal',
          minWidth: '300px', // prevents text from collapsing during animation
        }}>
          {description}
        </CardText>
      </div>
    </div>
  );
}